import {createAsyncThunk, createSlice, isAnyOf, PayloadAction} from '@reduxjs/toolkit';

import {
    confirmPhoneByEmail,
    confirmPhoneByFlashCall,
    confirmPhoneByPush,
    confirmPhoneBySms,
    confirmPhoneByUserCall,
    getConfirmationWays,
    verifyPhoneByEmail,
    verifyPhoneByFlashCall,
    verifyPhoneByPush,
    verifyPhoneBySms,
    verifyPhoneByUserCall
} from "./api";
import {
    ConfirmationWayModelArray,
    ConfirmPhoneByEmailModel,
    ConfirmPhoneByFlashCallModel,
    ConfirmPhoneByPushModel,
    ConfirmPhoneBySmsModel,
    ConfirmPhoneByUserCallModel,
    IConfirmPhoneByEmailProps,
    IConfirmPhoneByEmailResult,
    IConfirmPhoneByFlashCallProps,
    IConfirmPhoneByFlashCallResult,
    IConfirmPhoneByPushProps,
    IConfirmPhoneByPushResult,
    IConfirmPhoneBySmsProps,
    IConfirmPhoneBySmsResult,
    IConfirmPhoneByUserCallProps,
    IConfirmPhoneByUserCallResult,
    IGetConfirmationWaysParams,
    IGetConfirmationWaysResult,
    IPhoneConfirmationState, IVerifyPhoneByCallProps,
    IVerifyPhoneProps,
    IVerifyPhoneResult,
    VerifyPhoneModel
} from "../../../../interface/PhoneConfirmation";
import {IErrorResult, IServerError} from '../../../../interface/Basic/api';
import {PhoneConfirmationWay, PhoneVerifyStateId} from "../../../../enum/phoneConfirm";
import {LocalStorageEnum} from "../../../../enum/localStorage";

export const GetConfirmationWays = createAsyncThunk<IGetConfirmationWaysResult, IGetConfirmationWaysParams, {
    rejectValue: IErrorResult
}>
('GetConfirmationWays', (data, thunkAPI) => getConfirmationWays(data)
    .then(resolve => resolve)
    .catch((error: IServerError) => thunkAPI.rejectWithValue(error.response.data.error)))

export const ConfirmPhoneBySms = createAsyncThunk<IConfirmPhoneBySmsResult, IConfirmPhoneBySmsProps, {
    rejectValue: IErrorResult
}>
('ConfirmPhoneBySms', (data, thunkAPI) => confirmPhoneBySms(data)
    .then(resolve => resolve)
    .catch((error: IServerError) => thunkAPI.rejectWithValue(error.response.data.error)))

export const ConfirmPhoneByEmail = createAsyncThunk<IConfirmPhoneByEmailResult, IConfirmPhoneByEmailProps, {
    rejectValue: IErrorResult
}>
('ConfirmPhoneByEmail', (data, thunkAPI) => confirmPhoneByEmail(data)
    .then(resolve => resolve)
    .catch((error: IServerError) => thunkAPI.rejectWithValue(error.response.data.error)))

export const ConfirmPhoneByPush = createAsyncThunk<IConfirmPhoneByPushResult, IConfirmPhoneByPushProps, {
    rejectValue: IErrorResult
}>
('ConfirmPhoneByPush', (data, thunkAPI) => confirmPhoneByPush(data)
    .then(resolve => resolve)
    .catch((error: IServerError) => thunkAPI.rejectWithValue(error.response.data.error)))

export const ConfirmPhoneByFlashCall = createAsyncThunk<IConfirmPhoneByFlashCallResult, IConfirmPhoneByFlashCallProps, {
    rejectValue: IErrorResult
}>
('ConfirmPhoneByFlashCall', (data, thunkAPI) => confirmPhoneByFlashCall(data)
    .then(resolve => resolve)
    .catch((error: IServerError) => thunkAPI.rejectWithValue(error.response.data.error)))

export const ConfirmPhoneByUserCall = createAsyncThunk<IConfirmPhoneByUserCallResult, IConfirmPhoneByUserCallProps, {
    rejectValue: IErrorResult
}>
('ConfirmPhoneByUserCall', (data, thunkAPI) => confirmPhoneByUserCall(data)
    .then(resolve => resolve)
    .catch((error: IServerError) => thunkAPI.rejectWithValue(error.response.data.error)))

export const VerifyPhoneBySms = createAsyncThunk<IVerifyPhoneResult, IVerifyPhoneProps, {
    rejectValue: IErrorResult
}>
('VerifyPhoneBySms', (data, thunkAPI) => verifyPhoneBySms(data)
    .then(resolve => resolve)
    .catch((error: IServerError) => thunkAPI.rejectWithValue(error.response.data.error)))

export const VerifyPhoneByEmail = createAsyncThunk<IVerifyPhoneResult, IVerifyPhoneProps, {
    rejectValue: IErrorResult
}>
('VerifyPhoneByEmail', (data, thunkAPI) => verifyPhoneByEmail(data)
    .then(resolve => resolve)
    .catch((error: IServerError) => thunkAPI.rejectWithValue(error.response.data.error)))

export const VerifyPhoneByPush = createAsyncThunk<IVerifyPhoneResult, IVerifyPhoneProps, {
    rejectValue: IErrorResult
}>
('VerifyPhoneByPush', (data, thunkAPI) => verifyPhoneByPush(data)
    .then(resolve => resolve)
    .catch((error: IServerError) => thunkAPI.rejectWithValue(error.response.data.error)))

export const VerifyPhoneByFlashCall = createAsyncThunk<IVerifyPhoneResult, IVerifyPhoneProps, {
    rejectValue: IErrorResult
}>
('VerifyPhoneByFlashCall', (data, thunkAPI) => verifyPhoneByFlashCall(data)
    .then(resolve => resolve)
    .catch((error: IServerError) => thunkAPI.rejectWithValue(error.response.data.error)))

export const VerifyPhoneByUserCall = createAsyncThunk<IVerifyPhoneResult, IVerifyPhoneByCallProps, {
    rejectValue: IErrorResult
}>
('VerifyPhoneByUserCall', (data, thunkAPI) => verifyPhoneByUserCall(data)
    .then(resolve => resolve)
    .catch((error: IServerError) => thunkAPI.rejectWithValue(error.response.data.error)))

const initialState: IPhoneConfirmationState = {
    phone: null,
    ways: [],
    selectedWay: null,
    state_id: null,
    operation_id: null,
    confirmed: false,
    errorConfirm: false,
    confirmedByUserCall: false,
    delay: null,
    servicePhone: null,
    fetching: {},
    confirmNumberModalLoader: false,
    error: {},
}

export const slice = createSlice({
    name: 'phoneConfirmation',
    initialState,
    reducers: {
        setSelectedPhoneConfirmationWay(state, action: PayloadAction<PhoneConfirmationWay | null>) {
            state.selectedWay = action.payload
        },
        setSelectedConfirmationPhone(state, action: PayloadAction<string | null>) {
            state.phone = action.payload
        },
        clearPhoneConfirmationDelay(state) {
            state.delay = null
        },
        resetSelectedConfirmationWay(state) {
            state.phone = null
            state.selectedWay = null
            state.state_id = null
            state.operation_id = null
            state.servicePhone = null
        },
        resetPhoneConfirmation(state) {
            state.phone = null
            state.selectedWay = null
            state.state_id = null
            state.operation_id = null
            state.confirmed = false
            state.errorConfirm = false
            state.delay = null
            state.servicePhone = null
        },
        confirmByUserCallReset(state) {
            state.confirmedByUserCall = false
            state.confirmed = true
        },
        setPhoneConfirmed(state, action: PayloadAction<boolean>) {
            state.confirmed = action.payload
        },
        setPhoneErrorConfirmed(state, action: PayloadAction<boolean>) {
            state.errorConfirm = action.payload;
        },
        cleanError(state, action: PayloadAction<string>) {
            delete state.error[action.payload]
        },
        addError(state, action: PayloadAction<{ key: string, value: string }>) {
            state.error[action.payload.key] = action.payload.value
        },
        cleanAllErrors(state) {
            state.error = {}
        },
    },
    extraReducers: builder => {
        builder.addCase(GetConfirmationWays.pending, (state) => {
            state.ways = []
        })
        builder.addCase(GetConfirmationWays.fulfilled, (state, action) => {
            const result = ConfirmationWayModelArray.safeParse(action.payload.data)
            if (result.success) {
                state.ways = result.data
            } else {
                console.error(result.error)
            }
        })
        builder.addCase(ConfirmPhoneBySms.fulfilled, (state, action) => {
            const {access_token, retry_after} = ConfirmPhoneBySmsModel.parse(action.payload.data)
            localStorage.setItem(LocalStorageEnum.registerToken, access_token)
            state.phone = action.meta.arg.phone_number
            state.selectedWay = PhoneConfirmationWay.sms
            state.delay = retry_after

            state.confirmNumberModalLoader = false;
        })
        builder.addCase(ConfirmPhoneByEmail.fulfilled, (state, action) => {
            const {state_id, operation_id} = ConfirmPhoneByEmailModel.parse(action.payload.data)
            state.selectedWay = PhoneConfirmationWay.email
            state.state_id = state_id
            state.operation_id = operation_id
        })
        builder.addCase(ConfirmPhoneByPush.fulfilled, (state, action) => {
            const {state_id, operation_id} = ConfirmPhoneByPushModel.parse(action.payload.data)
            state.selectedWay = PhoneConfirmationWay.push
            state.state_id = state_id
            state.operation_id = operation_id
            state.confirmNumberModalLoader = false;
        })
        builder.addCase(ConfirmPhoneByFlashCall.fulfilled, (state, action) => {
            const {retry_after, access_token} = ConfirmPhoneByFlashCallModel.parse(action.payload.data)
            localStorage.setItem(LocalStorageEnum.registerToken, access_token)
            state.phone = action.meta.arg.phone_number
            state.selectedWay = PhoneConfirmationWay.flashCall
            state.delay = retry_after
            state.confirmNumberModalLoader = false;
        })

        builder.addCase(ConfirmPhoneByUserCall.fulfilled, (state, action) => {
            const {phone_number, operation_id} = ConfirmPhoneByUserCallModel.parse(action.payload.data)
            state.phone = action.meta.arg.phone_number
            state.servicePhone = phone_number
            state.selectedWay = PhoneConfirmationWay.userCall
            state.operation_id = operation_id
            state.deadline = { date: action.payload.data.deadline };
            state.confirmNumberModalLoader = false;
        })
        builder.addCase(VerifyPhoneByUserCall.fulfilled, (state, action) => {
            const parsed = VerifyPhoneModel.parse(action.payload.data)
            if (parsed.state_id === PhoneVerifyStateId.success) {
                state.confirmedByUserCall = true
            }
        })

        builder.addMatcher(isAnyOf(
            GetConfirmationWays.pending,
            ConfirmPhoneBySms.pending,
            VerifyPhoneBySms.pending,
            VerifyPhoneByFlashCall.pending,
        ), (state, action) => {
            state.fetching[action.type.split('/')[0]] = true
        })
        builder.addMatcher(isAnyOf(
            GetConfirmationWays.rejected,
            ConfirmPhoneBySms.rejected,
            VerifyPhoneBySms.rejected,
            VerifyPhoneByFlashCall.rejected,

            ConfirmPhoneBySms.fulfilled,
            GetConfirmationWays.fulfilled,
            VerifyPhoneBySms.fulfilled,
            VerifyPhoneByFlashCall.fulfilled,
        ), (state, action) => {
            delete state.fetching[action.type.split('/')[0]]
        })
        builder.addMatcher(isAnyOf(
            VerifyPhoneBySms.fulfilled,
            VerifyPhoneByEmail.fulfilled,
            VerifyPhoneByPush.fulfilled,
            VerifyPhoneByFlashCall.fulfilled,

        ), (state, action) => {
            const parsed = VerifyPhoneModel.parse(action.payload.data)
            if (parsed.state_id === PhoneVerifyStateId.success) {
                state.confirmed = true
            }
        })
        builder.addMatcher(isAnyOf(
            VerifyPhoneBySms.rejected,
            VerifyPhoneByEmail.rejected,
            VerifyPhoneByPush.rejected,
            VerifyPhoneByFlashCall.rejected,
            ConfirmPhoneBySms.rejected,

        ), (state, action) => {
            if (action.payload?.fields) {
                Object.entries(action.payload.fields).forEach((item) => {
                    const [key, values] = item
                    if (values && values.length !== 0) {
                        state.error[key] = values.join(', ')
                    }

                })
            }
        }),
        builder.addMatcher(
            isAnyOf(
              ConfirmPhoneByFlashCall.pending,
              ConfirmPhoneByPush.pending,
              ConfirmPhoneBySms.pending,
              ConfirmPhoneByUserCall.pending,
            ),
            (state) => {
              state.confirmNumberModalLoader = true;
              state.error = {};
            },
          );
          builder.addMatcher(
            isAnyOf(
              ConfirmPhoneByFlashCall.rejected,
              ConfirmPhoneByPush.rejected,
              ConfirmPhoneBySms.rejected,
              ConfirmPhoneByUserCall.rejected,
            ),
            (state) => {
              state.confirmNumberModalLoader = false;
            },
          );
    }
})
export const {
    setSelectedPhoneConfirmationWay,
    setSelectedConfirmationPhone,
    resetSelectedConfirmationWay,
    clearPhoneConfirmationDelay,
    resetPhoneConfirmation,
    confirmByUserCallReset,
    cleanError,
    setPhoneConfirmed,
    setPhoneErrorConfirmed,
} = slice.actions;


export default slice.reducer;
